export default __webpack_public_path__ + "c8b7ff20d0c0a86dadc1fa5fa77f58dc.ttf";